import React, { Component } from 'react';

import isEqual from 'lodash/isEqual';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ErrorBoundary } from '@sentry/react';

import * as Auth from './services/AuthService';
import Routes from './Routes';
import { login, logout } from './actions/userActions';
import { setLinks } from './actions/shopifyActions';
import './styles/containers/App.css';
import NavigationPanel from './components/utils/NavigationPanel';
import 'font-awesome/css/font-awesome.min.css';
import { trackMixpanel } from './infrastructure/utils/common';
import VersionService from './services/VersionService';
import NeedReloadAlert from './components/utils/NeedReloadAlert';
import ErrorBoundaryFallback from './components/utils/ErrorBoundaryFallback';
/* eslint-disable no-shadow */

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuthenticating: true,
      redirectToLogin: false,
      needReload: false,
    };
  }

  async componentDidMount() {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.versionService = new VersionService();
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.versionService.init(() => this.setState({ needReload: true }));

    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { logIn, init, shopifyLinks } = this.props;

    try {
      init(shopifyLinks);
      const user = await Auth.getUser();
      logIn(user);
    } catch (e) {
      this.setState({ redirectToLogin: true });
    }
    this.setState({ isAuthenticating: false });
  }

  componentDidUpdate(prevProps) {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { currentUser, mixpanel } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    if (!isEqual(currentUser, prevProps.currentUser)) {
      if (currentUser) {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        mixpanel.identify(currentUser.attributes.email);
        window.addEventListener('click', this.onWindowClick, { capture: true });
      } else {
        window.removeEventListener('click', this.onWindowClick);
      }
    }
  }

  componentWillUnmount() {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.versionService.destroy();
  }

  onWindowClick = event => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { mixpanel, currentUser } = this.props;
    const { target } = event;
    const tag = target.tagName.toLowerCase();
    if (tag === 'button')
      trackMixpanel(
        'buttonClicked',
        { buttonText: target.textContent },
        currentUser,
        mixpanel
      );
    if (tag === 'a')
      trackMixpanel(
        'linkClicked',
        {
          linkTitle: target.textContent,
          linkURL: target.href,
        },
        currentUser,
        mixpanel
      );
  };

  get isLoginPage() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { location } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    return location.pathname === '/login';
  }

  handleLogout = async () => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { logOut } = this.props;
    await Auth.logout();
    logOut();
    this.setState({ redirectToLogin: true });
  };

  render() {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { isAuthenticating } = this.state;
    if (isAuthenticating) {
      return false;
    }

    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { redirectToLogin, needReload } = this.state;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { isAuthenticated } = this.props;
    if (redirectToLogin && !this.isLoginPage && !isAuthenticated) {
      return <Redirect to='/login' />;
    }

    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { location } = this.props;
    return (
      <div className='container container-fluid'>
        <NeedReloadAlert show={needReload} />
        <NavigationPanel
          visual={isAuthenticated}
          location={location}
          logout={this.handleLogout}
        />
        <div
          className='
        col-xs-8 col-xs-offset-4
        col-sm-10 col-sm-offset-2
        col-md-10 col-md-offset-2
        main
        '
        >
          <ErrorBoundary fallback={<ErrorBoundaryFallback />}>
            <Routes {...this.props} />
          </ErrorBoundary>
        </div>
      </div>
    );
  }
}

// TODO: (fix build workaround) Need to be fixed next time when this code will be changed
// @ts-ignore
App.propTypes = { isAuthenticated: PropTypes.bool };
// TODO: (fix build workaround) Need to be fixed next time when this code will be changed
// @ts-ignore
App.defaultProps = { isAuthenticated: false };

function mapStateToProps(state) {
  return {
    currentUser: state.users.user,
    isAuthenticated: state.users.userHasAuthenticated,
    shopify: state.shopify.shopifyLinks,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    logIn: user => dispatch(login(user)),
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    logOut: () => dispatch(logout()),
    init: links => dispatch(setLinks(links)),
  };
}

const application = connect(mapStateToProps, mapDispatchToProps)(App);
export default withRouter(application);
